import { useCallback, useEffect, useState } from 'react';
import { StatusCodes } from 'http-status-codes';
import { useDispatch } from 'react-redux';

import { Type } from '../../Enum/Feedback/Type';
import { ResponseDTOInterface } from '../../Interface/Hook/Validator/ResponseDTOInterface';

import { fetchResult } from '../../Helpers/Validator/Response/FetchResult';
import { postValidatorFeedback } from '../../Service/FeedbackService';
import { timeout } from '../../Helpers/Validator/Timeout';
import { validatorFinishedLoading } from '../../Store/App/action';

const fetchData = (
    id: string,
    validatorResponse: ResponseDTOInterface,
    setValidatorResponse: (data: ResponseDTOInterface) => void,
): void => {
    fetchResult(id, validatorResponse.amountRequests).then(
        result => setValidatorResponse(result),
        error => setValidatorResponse(error),
    );
};

const useGetValidatorResponse = (id: string): ResponseDTOInterface => {
    const [validatorResponse, setValidatorResponse] = useState<ResponseDTOInterface>({
        amountRequests: 0,
        isLoading: true,
        result: null,
        retry: true,
        errorCode: undefined
    });

    const dispatch = useDispatch();

    const loadData = useCallback(() => {
        timeout(fetchData, id, validatorResponse, setValidatorResponse, validatorResponse.error ? 5000 : 2000);
    }, [id, validatorResponse]);

    useEffect(() => {
        if (validatorResponse.result === null && validatorResponse.errorCode === StatusCodes.PRECONDITION_REQUIRED) {
            return;
        }
        if (validatorResponse.result === null && validatorResponse.retry) {
            loadData();
        }
        if (validatorResponse.result === null && !validatorResponse.retry) {
            void postValidatorFeedback({
                name: 'Validator Error Report',
                message: `Er is een fout opgetreden bij het ophalen van de data binnen de validator. ${validatorResponse.error?.message}`,
                type: Type.PROBLEM,
                caseId: id,
            });
        }
        if (validatorResponse.result) {
            dispatch(validatorFinishedLoading(id, validatorResponse.label || ''));
        }
    }, [id, validatorResponse, loadData]);

    return validatorResponse;
};

export default useGetValidatorResponse;
